import { checkIsAreaPageLocked } from 'app/pages/system/autoLockRules/AutoLockRules.utils';
import _ from 'lodash';

import { hiddenSubTabs, tabNameToAutoLockArea } from './LoanNavigationTabs.constants';

const checkIsSubtabAutoLockHidden = (subtab, lockedPageIds) => {
  const area = tabNameToAutoLockArea[subtab.tabName];

  if (!area) {
    return false;
  }

  return checkIsAreaPageLocked({
    areaName: area.name,
    levelType: area.levelType,
    pageIds: lockedPageIds,
    hiddenOnly: true,
  });
};

const checkIsSubtabAutoLocked = (subtab, lockedPageIds) => {
  const area = tabNameToAutoLockArea[subtab.tabName];

  if (!area) {
    return false;
  }

  return checkIsAreaPageLocked({
    areaName: area.name,
    levelType: area.levelType,
    pageIds: lockedPageIds,
  });
};

const buildSubtabEntries = (
  subtabs,
  lockedPageIds,
  channelHiddenTabNames,
  channelReadOnlyTabNames,
) =>
  Object.entries(subtabs).reduce((acc, [subtabKey, subtab]) => {
    if (hiddenSubTabs.includes(subtab.tabName)) {
      return acc;
    }

    if (checkIsSubtabAutoLockHidden(subtab, lockedPageIds)) {
      return acc;
    }

    if (channelHiddenTabNames.includes(subtab.tabName)) {
      return acc;
    }

    const isChannelReadOnly = channelReadOnlyTabNames.includes(subtab.tabName);

    acc[subtabKey] = {
      ...subtab,
      isAutoLocked: isChannelReadOnly || checkIsSubtabAutoLocked(subtab, lockedPageIds),
    };

    return acc;
  }, {});

export const buildFilteredTabs = (
  availableTabs,
  lockedPageIds,
  channelHiddenTabNames = [],
  channelReadOnlyTabNames = [],
) =>
  Object.entries(availableTabs).reduce((acc, [tabKey, tabConfig]) => {
    if (channelHiddenTabNames.includes(tabConfig.tabName)) {
      return acc;
    }

    const isChannelReadOnly = channelReadOnlyTabNames.includes(tabConfig.tabName);

    acc.push([
      tabKey,
      {
        ...tabConfig,
        isAutoLocked: isChannelReadOnly || tabConfig.isAutoLocked,
        subtabs: _.isEmpty(tabConfig.subtabs)
          ? tabConfig.subtabs
          : buildSubtabEntries(
              tabConfig.subtabs,
              lockedPageIds,
              channelHiddenTabNames,
              channelReadOnlyTabNames,
            ),
      },
    ]);

    return acc;
  }, []);
